import { createFileRoute } from '@tanstack/react-router'
import { TasksRegisterPage } from '../../../features/tasks/register-page'
import { taskSearchSchema } from '../../../features/tasks/search'

export const Route = createFileRoute('/_app/tasks/')({
  validateSearch: taskSearchSchema,
  component: TasksRegisterPage,
})
